import { useEffect, useState, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import toast from 'react-hot-toast';

export default function RegisterPage() {
  const [form, setForm] = useState({ phone: '', smsCode: '', password: '', confirm: '', invite: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    const q = search.get('invite');
    if (q) { setForm(f => ({ ...f, invite: q })); setLocked(true); }
  }, [search]);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const sendSms = useCallback(async () => {
    if (countdown > 0) return;
    if (!/^1[3-9]\d{9}$/.test(form.phone)) { toast.error('请输入正确的手机号码'); return; }
    try {
      await api.post('/sms/send', { phone: form.phone });
      toast.success('验证码已发送');
      setCountdown(60);
    } catch (err: any) { toast.error(err?.response?.data?.message ?? '发送失败'); }
  }, [form.phone, countdown]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!/^1[3-9]\d{9}$/.test(form.phone)) { toast.error('请输入正确的手机号码'); return; }
    if (form.password !== form.confirm) { toast.error('两次密码不一致'); return; }
    if (!form.invite.trim()) { toast.error('请输入邀请码'); return; }
    if (!agreed) { toast.error('请阅读并同意用户注册协议和隐私政策'); return; }
    try {
      const name = form.phone.slice(-4);
      const { data } = await api.post('/register', { name, phone: form.phone, password: form.password, smsCode: form.smsCode, invite: form.invite });
      localStorage.setItem('token', data.token);
      toast.success('注册成功');
      navigate('/');
    } catch (err: any) { toast.error(err?.response?.data?.message ?? '错误'); }
  }

  return (
    <div className="min-h-screen w-full flex flex-col bg-[url(/images/reg_beijing.png)] bg-contain bg-no-repeat bg-top pb-[150px]">  
      {/* Registration form card */}
      <div className="px-4 mt-[330px] relative z-10">
        <div className="rounded-2xl p-6"> 
          <form onSubmit={submit} className="space-y-3">
            {/* Phone */}
            <div className="flex items-center bg-[#fff]/60 rounded-xl px-4 py-3 border border-[#ff6666]/20">
              <img src="/images/reg_shouji.png" alt="" className="w-5 h-5 mr-3 flex-shrink-0" />
              <input
                className="flex-1 text-sm focus:outline-none bg-transparent"
                placeholder="请输入手机号码"
                maxLength={11}
                value={form.phone}
                onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, '').slice(0, 11) })}
              />
            </div>

            {/* Invite code */}
            <div className="flex items-center bg-[#fff]/60 rounded-xl px-4 py-3 border border-[#ff6666]/20">
              <img src="/images/reg_yaoqing.png" alt="" className="w-5 h-5 mr-3 flex-shrink-0" />
              <input
                className="flex-1 text-sm focus:outline-none bg-transparent"
                placeholder="请输入邀请码（如有）"
                value={form.invite}
                onChange={e => setForm({ ...form, invite: e.target.value })}
                disabled={locked}
              />
            </div>

            {/* Password */}
            <div className="flex items-center bg-[#fff]/60 rounded-xl px-4 py-3 border border-[#ff6666]/20">
              <img src="/images/reg_mima.png" alt="" className="w-5 h-5 mr-3 flex-shrink-0" />
              <input
                className="flex-1 text-sm focus:outline-none bg-transparent"
                placeholder="请设置登录密码"
                type={showPwd ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
              />
              <button type="button" onClick={() => setShowPwd(!showPwd)} className="ml-2 flex-shrink-0">
                <img src="/images/reg_yanjing.png" alt="" className="w-5 h-4" style={{ opacity: showPwd ? 1 : 0.5 }} />
              </button>
            </div>

            {/* Confirm password */}
            <div className="flex items-center bg-[#fff]/60 rounded-xl px-4 py-3 border border-[#ff6666]/20">
              <img src="/images/reg_mima.png" alt="" className="w-5 h-5 mr-3 flex-shrink-0" />
              <input
                className="flex-1 text-sm focus:outline-none bg-transparent"
                placeholder="请再次输入登录密码"
                type={showConfirm ? 'text' : 'password'}
                value={form.confirm}
                onChange={e => setForm({ ...form, confirm: e.target.value })}
              />
              <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="ml-2 flex-shrink-0">
                <img src="/images/reg_yanjing.png" alt="" className="w-5 h-4" style={{ opacity: showConfirm ? 1 : 0.5 }} />
              </button>
            </div>


            {/* Agreement */}
            <label className="flex items-start justify-start gap-2 cursor-pointer select-none pt-1">
              <div
                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors text-[#fff] ${agreed ? 'bg-[#ca0000] border-[#ca0000]/30' : 'border-[#ca0000]/50'}`}
                onClick={() => setAgreed(!agreed)}
              >
                {agreed && <span className="text-[#fff] text-[8px] leading-none">&#10003;</span>}
              </div>
              <span className="text-[11px] leading-relaxed">
                我已阅读并同意
                <a href="/agreement" className="text-[#ca0000]" onClick={e => e.stopPropagation()}>《用户注册协议》</a>
                与
                <a href="/privacy" className="text-[#ca0000]" onClick={e => e.stopPropagation()}>《隐私政策》</a>
              </span>
            </label>

            {/* Submit button */}
            <button
              type="submit"
              className="w-full" 
            >
              <img src="/images/reg_iji.png" alt="" className="w-full" />
            </button>
          </form>

          {/* Login link */}
          <div className="flex items-center justify-between gap-1">
            <span></span>
            <span className="flex items-center justify-center gap-1 mt-1">
              <span className="text-xs">已有账号？</span>
              <a href="/login" className="text-xs text-[#ca0000] font-medium">立即登录</a>
            </span>
          </div>
        </div>

        <div className="mx-3">
            {/* Action cards */}
            <img src="/images/reg_others.png" alt="" className="w-full mt-1" />
            <div className="flex justify-center gap-1">
              <a href="/support">
                <img src="/images/reg_kefu.png" alt="" className="w-[150px] flex-shrink-0" />
              </a>
              <img src="/images/reg_line.png" alt="" className="w-[20px]" />
              <a href="/download">
                <img src="/images/reg_xiazai.png" alt="" className="w-[150px] flex-shrink-0" />
              </a>
            </div>
          </div> 
        </div>
    </div>
  );
}
